import { Icon, Report, Video } from 'components';
import { FC, useEffect, useState } from 'react';
import { IItem, ItemType } from 'types';
import cn from 'classnames';

import arrow from 'assets/sprite/arrow.svg';

import styles from './Category.module.scss';

export interface ICategory {
  title: string;
  items: IItem[];
  type: ItemType;
}

export const Category: FC<ICategory> = ({ title, items, type }) => {
  const [maxHeight, setMaxHeight] = useState(0);
  const [isActive, setIsActive] = useState(items?.length > 0);
  const [isEmpty, setIsEmpty] = useState(false);

  const handleClick = () => setIsActive(!isActive);

  useEffect(() => setMaxHeight(isActive ? null : 0), [isActive]);
  useEffect(() => {
    if (items.length === 0) {
      return setIsEmpty(true);
    }
  }, []);

  const getItemType: FC<IItem> = item => {
    if (type === ItemType.Report) {
      return (
        <Report
          type={type}
          key={item.id}
          id={item.id}
          filename_download={item.filename_download}
          isDownload={item.isDownload}
        />
      );
    }
    return (
      <Video
        type={type}
        key={item.id}
        id={item.id}
        filename_download={item.filename_download}
        isDownload={item.isDownload}
        video_type={item.video_type}
      />
    );
  };

  return (
    <div className={styles.root}>
      <div
        role="button"
        onClick={handleClick}
        className={cn(
          styles.button,
          { [styles.isActive]: isActive },
          { [styles.isInactive]: !isActive },
          { [styles.isEmpty]: isEmpty }
        )}
      >
        <div className={styles.buttonInfo}>
          <span className={styles.title}>{title}</span>
          <span className={styles.count}>{items.length}</span>
        </div>
        {!isEmpty && (
          <div className={styles.arrow}>
            <Icon id={arrow.id} viewBox={arrow.viewBox} className={styles.ico} />
          </div>
        )}
      </div>
      <div className={styles.content} style={{ maxHeight }}>
        <div className={styles.contentInner}>
          {isActive && !isEmpty && items.map(item => getItemType(item))}
        </div>
      </div>
    </div>
  );
};
